import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmParams } from 'APIPackage/KnmModule/interfaces/IKnmParams';

type DataType = Omit<
  IKnmParams,
  'startDate' | 'stopDate' | 'startTime' | 'stopTime' | 'prosecutorOrganization' | 'pmErknm' | 'version'
>;

export const createKnmPmStaticData = (knmData?: IKnm) => {
  const data: DataType = {
    auditedPersonAuthority: undefined,
    id: typeof knmData?.id === 'number' ? knmData?.id : null,
    erpId: knmData?.erpId || null,
    planId: typeof knmData?.planId === 'number' ? knmData?.planId : null,
    planGuid: typeof knmData?.planGuid === 'string' ? knmData?.planGuid : null,
    guid: knmData?.guid || null,
    status: knmData?.status || null,
    year: typeof knmData?.year === 'number' ? knmData?.year : null,
    month: null,
    creationDate: knmData?.creationDate || null,
    publicationDate: knmData?.publicationDate || null,
    type: null,
    kind: null,
    federalLaw: knmData?.federalLaw || null,
    title: knmData?.title || null,
    testPurchaseMethod: null,
    testPurchaseDescription: null,
    supervisionType: null,
    startDateIsMonth: null,
    approve: null,
    reasons: null,
    legalBases: null,
    events: null,
    signStatus: knmData?.signStatus || null,
    knoOrganization: null,
    inspectors: null,
    rejectReasons: null,
    organization: null,
    riskCategory: null,
    objects: null,
    objectsErvk: null,
    noticeMethod: null,
    noticeDate: null,
    documents: null,
    links: null,
    district: knmData?.district || null,
    requirements: null,
    deleted: typeof knmData?.deleted === 'boolean' ? knmData?.deleted : null,
    publishedStatus: knmData?.publishedStatus || null,
    manualPublish: typeof knmData?.manualPublish === 'boolean' ? knmData?.manualPublish : null,
    published: typeof knmData?.published === 'boolean' ? knmData?.published : null,
    correlationToken: knmData?.correlationToken || null,
    createdBy: knmData?.createdBy || null,
    updatedBy: knmData?.updatedBy || null,
    created: knmData?.created || null,
    updated: knmData?.updated || null,
    note: null,
    hash: knmData?.hash || null,
    signed: typeof knmData?.signed === 'boolean' ? knmData?.signed : null,
    draft: typeof knmData?.draft === 'boolean' ? knmData?.draft : null,
    draftSavedAt: knmData?.draftSavedAt || null,
    signatureInfo: knmData?.signatureInfo || null,
    dateCreate: knmData?.dateCreate || null,
    classificationDateCreate: knmData?.classificationDateCreate || null,
    publishDateCreate: knmData?.publishDateCreate || null,
    statusDateCreate: knmData?.statusDateCreate || null,
    knmErknm: null,
    subjectNotifications: null,
    resigningRequired: knmData?.resigningRequired ?? null,
  };

  return data;
};
